import { HttpErrorResponse } from '@angular/common/http';

export function getErrorCode(response: HttpErrorResponse, modulePrefix: string): string {
  if (response.error && response.error.error && response.error.error.code) {
    return `${modulePrefix}::${response.error.error.code}`;
  }

  return '';
}

export function getErrorData(response: HttpErrorResponse) {
  if (response.error && response.error.error && response.error.error.data) {
    return response.error.error.data;
  }

  return {};
}

export function getErrorMessage(response: HttpErrorResponse): string {
  if (response.error && response.error.error && response.error.error.message) {
    return response.error.error.message;
  }

  return '';
}

export function getErrorDetails(response: HttpErrorResponse, modulePrefix: string) {
  const errorCode = getErrorCode(response, modulePrefix);
  const data = getErrorData(response);
  const message = getErrorMessage(response);

  return { errorCode, data, message };
}

export function replaceErrorTags(template: string, data: Record<string, any>): string {
  return template.replace(/\{(\w+)\}/g, (_, key) => (key in data ? data[key] : `{${key}}`));
}
